// extracted by mini-css-extract-plugin
module.exports = {"container":"button_container_3bi-s","wrapper":"button_wrapper_2egOR","textContainer":"button_textContainer_1c_I_","wide":"button_wide_AM1qs","disabled":"button_disabled__bpBU"};